<template lang="pug">
  a.NotificationsListMarkReadBtn.mark-read(
    :class="{'mark-read__complete': value, 'mark-read__active': loading}"
  )
    span.mark-read__text Mark All as Read
    .mark-read__circle
      svg.mark-read__circle--svg(xmlns="http://www.w3.org/2000/svg"
        viewBox="22.06896551724138 22.06896551724138 44.13793103448276 44.13793103448276"
        style="transform: rotate(0deg);"
      )
        circle.mark-read__circle--overlay(
          fill="transparent"
          cx="44.13793103448276"
          cy="44.13793103448276"
          r="20"
          stroke-width="2"
          stroke-dasharray="125.664"
          stroke-dashoffset="125.66370614359172px"
        )
      SolidCheckIcon.mark-read__circle--svg-icon
</template>

<script>
import SolidCheckIcon from 'images/svg-icons/solid-check.svg';

export default {
  name: 'NotificationsListMarkReadBtn',
  components: {
    SolidCheckIcon,
  },
  props: {
    value: Boolean,
    loading: Boolean,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.mark-read
  display: flex
  flex-direction: row
  align-items: center
  &__text
    color: $text_gray
    font-size: 14px
    line-height: 20px
    +font(600)
    margin-right: 6px
    +mt(.3s)
    @media screen and (max-width: 767px)
      font-size: 12px
      line-height: 19px
  &__circle
    width: 20px
    height: 20px
    border: 0.5px solid $mercury
    background: $support_lightgray
    border-radius: 100px
    position: relative
    +mt(.3s)
    @media screen and (max-width: 767px)
      width: 16px
      height: 16px
    &--svg
      position: absolute
      left: -2px
      top: -1px
      opacity: 0
      +mt(.3s)
      width: 21px
      height: 21px
      transition: all .2s ease-in-out
      transform-origin: center center
      animation: progress-circular-rotate 1.4s linear infinite
      @media screen and (max-width: 767px)
        width: 17px
        height: 17px
    &--overlay
      stroke-dashoffset: 0px
      stroke-dasharray: 100, 200
      stroke-linecap: round
      animation: progress-circular-dash 1.4s ease-in-out infinite
      stroke: $text_gray
    &--svg-icon
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: 10px
      height: 8px
      fill: $text_gray
      @media screen and (max-width: 767px)
        width: 8px
        height: 6px
  &__active
    pointer-events: none
    .mark-read__text
      opacity: 0
    .mark-read__circle
      border: 0.5px solid transparent
      background: transparent
      &--svg
        opacity: 1
        +mt(.3s)
      &--svg-icon
        opacity: 0
  &__complete
    pointer-events: none
    .mark-read__text
      opacity: 0
    .mark-read__circle
      border: 0.5px solid $secondary !important
      background: $secondary
      &--svg-icon
        fill: $white
  &:hover
    .mark-read__text
      color: $primary
      +mt(.3s)
    &:not(.mark-read__active)
      .mark-read__circle
        border: 0.5px solid $text_gray
        +mt(.3s)
</style>
